"use client";
const r = (o) => ({
  "--color-component": "var(--color-" + o + ")",
  "--color-component-foreground": "var(--color-" + o + "-foreground)"
});
export {
  r as setComponentColor
};
